import { makeStyles } from "@material-ui/core/styles";

export default makeStyles(() => ({
  small: {
    maxHeight: 28,
  },
}));
